import request from '@app/utils/apiRequest';

export const requestSaveJobPipeline = (data) => request.post(`/job/job-pipeline/save`, data)
export const requestGetJobPipeLineList = (params) => request.get(`/job/job-pipeline/list`, {params: params});
export const requestGetJobPipeLine = (params) => request.get(`/job/job-pipeline/detail`, {params: params});

export const requestDeleteJobPipeline = (data) =>
    request.delete(`/job/job-pipeline/delete`, {data: data});

export const requestCheckPersonInJobPipeline = (data) =>
    request.post(`/job/job-pipeline/exists-person`, data);

export const requestCompareCandidatesFromList = (data) =>
    request.post(`/job/job-pipeline/compare-candidates`, data);

export const requestCopyPipelineFromJob = (data) =>
    request.post(`/job/job-pipeline/copy-pipelines-from-job`, data);
